/**
 * Produktseite v60 (Bau 03.10.2026) — Verhalten der Sektionen product-v60-*.
 * Ergänzt assets/variant-picker.js (Variantenwahl, Preis, Galerie) und assets/product-gallery.js
 * (Galerie, Großansicht). Kein Framework. Ohne JavaScript bleibt die Seite vollständig lesbar,
 * das Formular schickt die gewählte Variante ab.
 * Agenten testen hier nur Markup und Formularfelder; der Warenkorb wird nicht abgeschickt.
 */
(function () {
  var root = document.querySelector('[data-v6-main]');
  var money = function (c) {
    if (typeof window.cryonosMoney === 'function') return window.cryonosMoney(c);
    return (c / 100).toFixed(2);
  };
  var strings = {};
  try { strings = JSON.parse((document.querySelector('[data-v6-strings]') || {}).textContent || '{}'); } catch (e) {}
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Kaufbox: Menge, Variante, Zubehör, Summe ---------- */
  var state = { price: 0, sku: '', variant: null, qty: 1 };
  var AW = window.CryonosAuswahl; /* AUFTRAG-95: auswahl-link.js steht vor diesem Skript */
  var topPos = null;
  var buybox = root && root.querySelector('[data-v6-buybox]');
  var mdrIds = '';
  if (buybox) {
    state.price = parseInt(buybox.getAttribute('data-v6-price'), 10) || 0;
    var skuEl = buybox.querySelector('[data-v6-sku]');
    state.sku = skuEl ? skuEl.textContent : '';
    state.variantId = buybox.getAttribute('data-v6-variant');
    state.hasVersion = buybox.getAttribute('data-v6-has-version') === '1';
    state.isMdr = buybox.getAttribute('data-v6-is-mdr') === '1';
    mdrIds = buybox.getAttribute('data-v6-mdr-ids') || '';
  }
  /* AUFTRAG-88 Nr. 2: MDR-Variante an der Varianten-ID erkennen ("|id|id|" aus snippets/variant-roles), nie am übersetzten Optionstext. */
  function isMdrVariant(v) {
    return !!(v && mdrIds && mdrIds.indexOf('|' + v.id + '|') >= 0);
  }
  var form = root && root.querySelector('form.v6-form');
  var qtyInput = root && root.querySelector('[data-v6-qty-input]');
  var addonInputs = root && root.querySelector('[data-v6-addon-inputs]');

  function addons() {
    if (!root) return [];
    return Array.prototype.slice.call(root.querySelectorAll('[data-v6-addon]')).map(function (row) {
      var cb = row.querySelector('[data-v6-addon-check]');
      var sel = row.querySelector('[data-v6-addon-opt]');
      var prEl = row.querySelector('[data-v6-addon-price]');
      var id = sel ? sel.value : cb.value;
      var price = sel ? parseInt(sel.options[sel.selectedIndex].getAttribute('data-price'), 10) : parseInt(prEl.getAttribute('data-price'), 10);
      var name = (row.querySelector('.v6-aor__nm b') || {}).textContent || '';
      var small = row.querySelector('.v6-aor__nm small');
      var opt = sel ? sel.options[sel.selectedIndex].textContent : (small ? small.textContent : '');
      return { row: row, on: cb.checked, id: id, price: price || 0, name: name, opt: (opt || '').trim(), prEl: prEl };
    });
  }

  function quoteItems(list) {
    var idInput = form && form.querySelector('[data-variant-id-input]');
    var vid = (idInput && idInput.value) || state.variantId || '';
    var qty = state.qty || 1;
    var mainHandle = root ? (root.getAttribute('data-v6-handle') || '') : '';
    var items = [];
    if (mainHandle) items.push(String(vid).replace(/\D/g, '') + ':' + qty + ':' + mainHandle);
    (list || addons()).forEach(function (a) {
      var h = a.row.getAttribute('data-handle');
      if (!a.on || !h) return;
      items.push(String(a.id || '').replace(/\D/g, '') + ':' + qty + ':' + h);
    });
    return items;
  }

  function updateQuoteLinks(list) {
    if (!root) return;
    var items = quoteItems(list);
    if (!items.length) return;
    root.querySelectorAll('[data-quote-link]').forEach(function (a) {
      try {
        var u = new URL(a.getAttribute('href'), window.location.href);
        ['product', 'variant', 'positions', 'qty'].forEach(function (k) { u.searchParams.delete(k); });
        u.searchParams.set('items', items.join(','));
        u.searchParams.set('src', 'product');
        a.setAttribute('href', u.pathname + u.search);
      } catch (e) {}
    });
  }

  function render() {
    if (!buybox) return;
    var list = addons();
    var qty = state.qty;
    var total = state.price;
    var lines = buybox.querySelector('[data-v6-lines]');
    var html = '<b>' + qty + ' × ' + escapeHtml(state.sku) + '</b> ' + money(state.price);
    var nOn = 0;
    list.forEach(function (a) {
      a.row.classList.toggle('is-on', a.on);
      if (a.prEl) a.prEl.textContent = '+ ' + money(a.price);
      if (a.on) {
        nOn++;
        total += a.price;
        html += '<br>' + qty + ' × ' + escapeHtml(a.name) + ' ' + money(a.price);
      }
    });
    total = total * qty;
    if (lines) lines.innerHTML = html;
    root.querySelectorAll('[data-v6-total]').forEach(function (el) { el.textContent = money(total); });
    var sp = root.querySelector('[data-v6-sbar-p]');
    if (sp) sp.textContent = money(total);
    var sv = root.querySelector('[data-v6-sbar-v]');
    if (sv) sv.textContent = state.sku + (nOn ? ' · ' + (nOn === 1 ? String(strings.items1 || '+1') : String(strings.items2 || '+2').replace('2', nOn)) : '');
    /* Formularfelder (Q7): ohne Zubehör die üblichen Felder id/quantity; mit Zubehör items[n][id] /
       items[n][quantity] für Gerät und jedes angehakte Teil (Shopify /cart/add). */
    if (form && addonInputs) {
      var idInput = form.querySelector('[data-variant-id-input]');
      addonInputs.innerHTML = '';
      if (nOn) {
        if (idInput) idInput.name = 'items[0][id]';
        if (qtyInput) qtyInput.name = 'items[0][quantity]';
        var i = 1;
        list.forEach(function (a) {
          if (!a.on || !a.id) return;
          addonInputs.insertAdjacentHTML('beforeend', '<input type="hidden" name="items[' + i + '][id]" value="' + a.id + '"><input type="hidden" name="items[' + i + '][quantity]" value="' + qty + '">');
          i++;
        });
      } else {
        if (idInput) idInput.name = 'id';
        if (qtyInput) qtyInput.name = 'quantity';
      }
    }
    /* Angebotsanfrage – A65 (Strategie 04.10.2026): Gerät (gewählte Variante) und JEDES angehakte Zubehör gehen als
       Varianten-ID + Menge an die Anfrageseite (?items=<id>:<menge>:<handle>,…), dort dieselbe Liste wie aus dem
       Warenkorb (sections/request-a-quote.liquid). Ersetzt den Text-Weg ?positions=. Der Link wird zusätzlich beim
       Klick neu gebaut (siehe unten), damit auch nach „Zurück“ im Browser wiederhergestellte Häkchen mitkommen. */
    updateQuoteLinks(list);
    /* Kacheln „Fits the …“: angehakte Teile markieren */
    var onIds = {};
    list.forEach(function (a) { if (a.on) onIds[a.id] = true; });
    document.querySelectorAll('[data-v6-fc-state]').forEach(function (el) {
      var ids = (el.getAttribute('data-variant-ids') || '').split(',');
      var hit = ids.some(function (id) { return onIds[id]; });
      el.textContent = hit ? '✓ ' + el.getAttribute('data-in-order') : el.getAttribute('data-view');
    });
  }

  if (root) {
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-quote-link]')) updateQuoteLinks();
    }, true);
    window.addEventListener('pageshow', function () { if (buybox) render(); });
  }

  /* A45 (Strategie 04.10.2026, Entscheidung Q7): „In den Warenkorb“ legt Gerät UND jedes angehakte Zubehör (gewählte Variante,
     gleiche Menge) mit EINEM Aufruf /cart/add.js in den Warenkorb. Schlägt das fehl, kommt das Gerät allein hinein und danach jedes
     Zubehör einzeln; was fehlt, wird namentlich gemeldet. Ohne angehaktes Zubehör bleibt der bisherige Weg (assets/cart-drawer.js). */
  function cartPayload() {
    var idInput = form && form.querySelector('[data-variant-id-input]');
    var qty = state.qty || 1;
    var items = [];
    var names = [];
    var missing = [];
    if (idInput && idInput.value) { items.push({ id: Number(idInput.value), quantity: qty }); names.push(state.sku); }
    addons().forEach(function (a) {
      if (!a.on) return;
      if (!a.id) { missing.push(a); return; }
      items.push({ id: Number(a.id), quantity: qty });
      /* AUFTRAG-88 Nr. 2: a.opt ist leer, wenn der Zubehör-Artikel nur die Standardvariante hat (Liquid gibt dann keinen Text aus). */
      names.push(a.name.trim() + (a.opt ? ' (' + a.opt + ')' : ''));
    });
    return { items: items, names: names, missing: missing };
  }
  window.v6CartPayload = function () { var p = cartPayload(); return { items: p.items, names: p.names, missing: p.missing.map(function (a) { return a.name.trim(); }) }; };

  function cartMsg(text) {
    if (!buybox) return;
    var el = buybox.querySelector('[data-v6-cart-msg]');
    if (!el) {
      el = document.createElement('p');
      el.className = 'v6-cart-msg';
      el.setAttribute('data-v6-cart-msg', '');
      el.setAttribute('role', 'alert');
      var acts = buybox.querySelector('.v6-acts');
      if (acts && acts.parentNode) acts.parentNode.insertBefore(el, acts.nextSibling); else buybox.appendChild(el);
    }
    el.textContent = text;
    el.hidden = !text;
  }

  function postItems(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (res) { if (!res.ok) throw res; return res.json(); });
  }

  function cartDone() {
    if (window.CryonosCartDrawer && typeof window.CryonosCartDrawer.refresh === 'function') return window.CryonosCartDrawer.refresh();
    window.location.href = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart';
  }

  if (form) {
    form.addEventListener('submit', function (e) {
      var submitter = e.submitter;
      if (submitter && submitter.name !== 'add') return;
      var p = cartPayload();
      if (p.items.length < 2 && !p.missing.length) return; /* nur das Gerät: bisheriger Weg */
      e.preventDefault();
      e.stopImmediatePropagation();
      if (p.missing.length) {
        cartMsg((strings.size_hint || 'Please choose the size.') + ' ' + p.missing.map(function (a) { return a.name.trim(); }).join(', '));
        var sel = p.missing[0].row.querySelector('[data-v6-addon-opt]');
        if (sel) sel.focus();
        return;
      }
      cartMsg('');
      if (submitter) submitter.disabled = true;
      postItems(p.items).then(cartDone).catch(function () {
        /* Fehlerfall: Gerät allein, dann jedes Zubehör einzeln; fehlende Teile nennen. */
        var failed = [];
        var chain = postItems([p.items[0]]).catch(function () { failed.push(p.names[0]); });
        p.items.slice(1).forEach(function (it, i) {
          chain = chain.then(function () { return postItems([it]).catch(function () { failed.push(p.names[i + 1]); }); });
        });
        return chain.then(function () {
          if (failed.length) cartMsg((strings.cart_error || 'The cart could not be updated.') + ' ' + failed.join(', '));
          if (failed.length < p.items.length) return cartDone();
        });
      }).then(function () { if (submitter) submitter.disabled = false; }, function () { if (submitter) submitter.disabled = false; });
    });
  }

  /* A56 (04.10.2026): Herz „Merkliste“ auf v60 merkt Gerät + jedes angehakte Zubehör (gewählte Variante, Menge), ohne Doppel;
     danach kurze Bestätigung „3 Artikel gemerkt“. Ohne Zubehör: Gerät merken bzw. wieder entfernen wie bisher. */
  if (root) {
    root.addEventListener('click', function (e) {
      var heart = e.target.closest('[data-wishlist-toggle]');
      if (!heart || !window.cryonosWishlist || !window.cryonosWishlist.saveMany) return;
      var handle = heart.getAttribute('data-wishlist-toggle');
      var on = addons().filter(function (a) { return a.on && a.id; });
      var w = window.cryonosWishlist;
      if (!on.length && w.isSaved(handle)) return; /* entfernen: bisheriger Weg (assets/wishlist.js) */
      e.preventDefault();
      e.stopPropagation();
      var idInput = form && form.querySelector('[data-variant-id-input]');
      var entries = [{ handle: handle, variant: idInput ? idInput.value : '', qty: state.qty || 1 }];
      on.forEach(function (a) { var h = a.row.getAttribute('data-handle'); if (h) entries.push({ handle: h, variant: a.id, qty: state.qty || 1 }); });
      var n = w.saveMany(entries);
      var t = String(strings.wl_saved || '{count} items saved').replace('{count}', n).replace('{{ count }}', n);
      cartMsg(t);
      setTimeout(function () { var el = buybox && buybox.querySelector('[data-v6-cart-msg]'); if (el && el.textContent === t) el.hidden = true; }, 4000);
    });
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  }

  if (root) {
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-v6-qty] [data-step]');
      if (b && qtyInput) {
        state.qty = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + parseInt(b.getAttribute('data-step'), 10));
        qtyInput.value = state.qty;
        render();
        auswahlUpdate();
      }
      var info = e.target.closest('[data-v6-info]');
      if (info) {
        var pop = document.getElementById(info.getAttribute('aria-controls'));
        if (pop) {
          var open = pop.hidden;
          pop.hidden = !open;
          info.setAttribute('aria-expanded', open ? 'true' : 'false');
        }
      }
    });
    if (qtyInput) qtyInput.addEventListener('change', function () {
      state.qty = Math.max(1, parseInt(qtyInput.value, 10) || 1);
      qtyInput.value = state.qty;
      render();
      auswahlUpdate();
    });
    root.addEventListener('change', function (e) {
      var row = e.target.closest('[data-v6-addon]');
      if (row) {
        var sel = row.querySelector('[data-v6-addon-opt]');
        var hint = row.querySelector('[data-v6-addon-hint]');
        if (hint && sel && sel.value) hint.hidden = true;
        render();
        auswahlUpdate();
      }
    });
    root.addEventListener('variant:changed', function (e) {
      var v = e.detail && e.detail.variant;
      if (!v) return;
      state.price = v.price;
      state.sku = v.sku || state.sku;
      root.querySelectorAll('[data-v6-sku]').forEach(function (el) { el.textContent = state.sku; });
      state.variantId = v.id;
      state.isMdr = isMdrVariant(v);
      render();
      document.dispatchEvent(new CustomEvent('v6:variant', { detail: { variant: v } }));
    });
    auswahlRestore();
    render();
  }

  /* ---------- AUFTRAG-95: Adresse folgt der Auswahl (assets/auswahl-link.js) ----------
     Parameter: z = angehakte Zubehörteile (Handle, bei mehreren Ausführungen ~SKU), q = Menge, p = Position der Draufsicht.
     Variante: Shopify setzt sie beim Laden aus ?variant=, variant-picker.js und auswahl-link.js schreiben sie zurück. */
  function auswahlUpdate() { if (AW) AW.update(true); }
  /* SKU nur, wenn sie unter den Ausführungen des Teils eindeutig ist (manche SKUs wiederholen sich); sonst die Varianten-ID mit # */
  function optSku(o) {
    var sku = o.getAttribute('data-sku'), n = 0;
    Array.prototype.forEach.call(o.parentNode.options, function (x) { if (sku && x.getAttribute('data-sku') === sku) n++; });
    return sku && n === 1 ? sku : '#' + o.value;
  }
  function auswahlState() {
    var out = {};
    var z = [];
    if (root) addons().forEach(function (a) {
      var h = a.row.getAttribute('data-handle');
      if (!a.on || !h) return;
      var sel = a.row.querySelector('[data-v6-addon-opt]');
      z.push(AW.itemStr(h, sel && sel.selectedIndex >= 0 && sel.value ? optSku(sel.options[sel.selectedIndex]) : ''));
    });
    out.z = z.length ? z.join(',') : null;
    out.q = state.qty > 1 ? String(state.qty) : null;
    out.p = topPos ? String(topPos) : null;
    return out;
  }
  function auswahlRestore() {
    if (!AW) return;
    AW.register(auswahlState);
    var q = AW.readInt('q');
    if (q && qtyInput) { state.qty = q; qtyInput.value = q; }
    var zl = AW.readList('z');
    if (zl.length) {
      addons().forEach(function (a) {
        var h = a.row.getAttribute('data-handle');
        var hit = zl.filter(function (x) { return x.h === h; })[0];
        if (!hit) return;
        var sel = a.row.querySelector('[data-v6-addon-opt]');
        var cb = a.row.querySelector('[data-v6-addon-check]');
        if (sel && hit.s) {
          var o = Array.prototype.filter.call(sel.options, function (op) { return op.value && optSku(op) === hit.s; })[0];
          if (!o) return; /* unbekannte Ausführung: Teil bleibt abgewählt (Standard) */
          sel.value = o.value;
        }
        var id = sel ? sel.value : cb.value;
        if (!id) return; /* Ausführung unbekannt oder nicht gewählt: Standard */
        var hint = a.row.querySelector('[data-v6-addon-hint]');
        if (hint) hint.hidden = true;
        cb.checked = true;
      });
    }
  }
  /* Position der Draufsicht: nach dem Anbinden der Klick-Ereignisse (unten) */
  function auswahlRestorePos() {
    var p = AW && AW.readInt('p');
    if (!p) return;
    var g = document.querySelector('[data-v6-topview] .v6-pos[data-p="' + (p - 1) + '"]');
    if (g) g.dispatchEvent(new MouseEvent('click', { bubbles: true }));
  }

  /* ---------- Datenblatt: goldene Werte folgen der Auswahl ---------- */
  /* Straw-Gesamtwerte: Variantenwert zuerst, sonst Produktwert (Entscheidung 16.10.2026). Karte aus data-v6-straw-map. */
  var strawMap = null;
  try { var smEl = document.querySelector('[data-v6-straw-map]'); if (smEl) strawMap = JSON.parse(smEl.textContent); } catch (err) { strawMap = null; }
  function updateStraws(v) {
    if (!strawMap || !strawMap.base) return;
    var own = (strawMap.v && strawMap.v[String(v.id)]) || {};
    ['25', '05'].forEach(function (sz) {
      var val = own[sz], calc = false;
      if (!val) { val = strawMap.base[sz]; calc = !!strawMap.base['c' + sz]; }
      document.querySelectorAll('[data-v6-straw="' + sz + '"]').forEach(function (el) { if (val) el.textContent = val; });
      document.querySelectorAll('[data-v6-straw-calc="' + sz + '"]').forEach(function (el) { el.style.display = (val && calc) ? '' : 'none'; });
      document.querySelectorAll('[data-v6-straw-row="' + sz + '"]').forEach(function (el) { el.style.display = val ? '' : 'none'; });
    });
  }
  document.addEventListener('v6:variant', function (e) {
    var v = e.detail.variant;
    updateStraws(v);
    var isMdr = isMdrVariant(v);
    document.querySelectorAll('[data-v6-ds="sku"]').forEach(function (el) { el.textContent = v.sku || el.textContent; });
    document.querySelectorAll('[data-v6-ds="price"]').forEach(function (el) { el.textContent = money(v.price); });
    document.querySelectorAll('[data-v6-ds="version"]').forEach(function (el) {
      el.textContent = isMdr ? 'MDR' : (strings.standard || 'Standard');
    });
  });

  /* ---------- Galerie: Zähler, Großansicht-Knopf, Maße ---------- */
  var stage = root && root.querySelector('[data-v6-stage]');
  if (stage) {
    var idx = stage.querySelector('[data-pg-index]');
    var cnt = root.querySelector('[data-v6-cnt]');
    // Variantenbilder (V3): the gallery total follows the selected variant (data-pg-total); the
    // counter hides with only one image, like the gallery's own arrows (.pg--single).
    var tot = stage.querySelector('[data-pg-total]');
    var cntTot = root.querySelector('[data-v6-cnt-total]');
    var cntWrap = cnt ? cnt.closest('.v6-cnt') : null;
    function syncTotal() {
      if (!tot || !cntTot) return;
      cntTot.textContent = tot.textContent;
      if (cntWrap) cntWrap.hidden = (parseInt(tot.textContent, 10) || 0) < 2;
    }
    if (idx) {
      // AUFTRAG-92: the counter is the gallery's own (.pg__count); [data-v6-cnt] is optional.
      new MutationObserver(function () { if (cnt) cnt.textContent = idx.textContent; syncTotal(); drawDims(); }).observe(idx, { childList: true, characterData: true, subtree: true });
    }
    if (tot) new MutationObserver(syncTotal).observe(tot, { childList: true, characterData: true, subtree: true });
    function shownItems() {
      return Array.prototype.filter.call(stage.querySelectorAll('.pg__item'), function (li) { return getComputedStyle(li).display !== 'none'; });
    }
    var zoomBtn = root.querySelector('[data-v6-zoom-btn]');
    if (zoomBtn) zoomBtn.addEventListener('click', function () {
      var n = idx ? (parseInt(idx.textContent, 10) || 1) : 1;
      var btns = shownItems().map(function (li) { return li.querySelector('[data-pg-open]'); });
      var b = btns[n - 1] || btns[0];
      if (b) b.click();
    });
    var dims = stage.querySelector('[data-v6-dims]');
    var dimBtn = root.querySelector('[data-v6-dims-btn]');
    function currentImg() {
      var n = idx ? (parseInt(idx.textContent, 10) || 1) : 1;
      var items = shownItems();
      var it = items[n - 1] || items[0];
      return it ? it.querySelector('img') : null;
    }
    function drawDims() {
      if (!dims || !stage.classList.contains('is-dims')) return;
      var img = currentImg();
      if (!img) return;
      var s = stage.getBoundingClientRect(), r0 = img.getBoundingClientRect();
      if (!r0.width) return;
      /* Sichtbaren Behälter statt Bildrahmen messen: Bild steht mit object-fit: contain im Rahmen,
         der freigestellte Bereich kommt aus assets/photo-fit.js (probe). */
      var fit = img.closest('[data-pg-fit]');
      var bb = fit && fit._v6bb;
      if (fit && !fit._v6probe && window.CryonosPhotoFit) {
        fit._v6probe = true;
        window.CryonosPhotoFit.probe(fit.getAttribute('data-probe')).then(function (v) { fit._v6bb = v; drawDims(); });
      }
      var r = { left: r0.left, top: r0.top, right: r0.right, bottom: r0.bottom, width: r0.width, height: r0.height };
      if (bb && bb.ar) {
        var dw = r0.width, dh = r0.height;
        if (r0.width / r0.height > bb.ar) { dw = r0.height * bb.ar; } else { dh = r0.width / bb.ar; }
        var dx = r0.left + (r0.width - dw) / 2, dy = r0.top + (r0.height - dh) / 2;
        r = { left: dx + bb.l * dw, right: dx + bb.r * dw, top: dy + bb.t * dh, bottom: dy + bb.b * dh };
        r.width = r.right - r.left; r.height = r.bottom - r.top;
      }
      var svg = dims.querySelector('svg');
      var x0 = r.left - s.left, x1 = r.right - s.left;
      var y0 = r.top - s.top, y1 = r.bottom - s.top;
      var lx = Math.min(x1 + 24, s.width - 70), cx = (x0 + x1) / 2, dn = parseFloat(dims.getAttribute('data-dn')), nn = parseFloat(dims.getAttribute('data-nn')), nw = (dn > 0 && nn > 0) ? r.width * nn / dn : r.width * 0.26;
      var h = dims.getAttribute('data-h'), d = dims.getAttribute('data-d'), nk = dims.getAttribute('data-neck');
      svg.setAttribute('viewBox', '0 0 ' + s.width + ' ' + s.height);
      var out = '<path d="M' + (x1 + 6) + ' ' + y0 + 'H' + (lx + 8) + 'M' + (x1 + 6) + ' ' + y1 + 'H' + (lx + 8) + '"/>' +
        '<line x1="' + lx + '" y1="' + y0 + '" x2="' + lx + '" y2="' + y1 + '"/>' +
        '<text x="' + (lx + 10) + '" y="' + ((y0 + y1) / 2) + '">' + h + ' mm</text>' +
        '<path d="M' + x0 + ' ' + (y1 + 8) + 'V' + (y1 + 26) + 'M' + x1 + ' ' + (y1 + 8) + 'V' + (y1 + 26) + '"/>' +
        '<line x1="' + x0 + '" y1="' + (y1 + 18) + '" x2="' + x1 + '" y2="' + (y1 + 18) + '"/>' +
        '<text x="' + (cx - 30) + '" y="' + (y1 + 40) + '">Ø ' + d + ' mm</text>';
      if (nk) {
        out += '<line x1="' + (cx - nw / 2) + '" y1="' + (y0 - 14) + '" x2="' + (cx + nw / 2) + '" y2="' + (y0 - 14) + '"/>' +
          '<text x="' + (cx + nw / 2 + 8) + '" y="' + (y0 - 10) + '">' + escapeHtml(dims.getAttribute('data-neck-label') || '') + ' ' + nk + ' mm</text>';
      }
      svg.innerHTML = out;
    }
    if (dimBtn && dims) {
      dimBtn.addEventListener('click', function () {
        var on = !stage.classList.contains('is-dims');
        stage.classList.toggle('is-dims', on);
        dimBtn.setAttribute('aria-pressed', on ? 'true' : 'false');
        drawDims();
      });
      window.addEventListener('resize', drawDims);
      stage.addEventListener('scroll', drawDims, true);
    }
  }

  /* ---------- Mitlaufende Kaufleiste ---------- */
  var sbar = root && root.querySelector('[data-v6-sbar]');
  if (sbar && buybox && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var en = entries[0];
      var on = !en.isIntersecting && en.boundingClientRect.top < 0;
      sbar.classList.toggle('is-on', on);
      sbar.setAttribute('aria-hidden', on ? 'false' : 'true');
      var a = sbar.querySelector('a');
      if (a) a.tabIndex = on ? 0 : -1;
    }).observe(buybox);
  }

  /* ---------- Vergleich-Link: ohne Vergleichsbereich zur Vergleichsseite ---------- */
  document.querySelectorAll('[data-v6-cmp-link]').forEach(function (a) {
    if (!document.getElementById('v6-compare')) a.href = a.getAttribute('data-fallback');
  });

  /* ---------- Sprungleiste: fehlende Ziele ausblenden, aktiver Abschnitt ---------- */
  var nav = document.querySelector('[data-v6-subnav]');
  if (nav) {
    var links = Array.prototype.slice.call(nav.querySelectorAll('a[data-v6-target]'));
    links.forEach(function (a) { if (!document.getElementById(a.getAttribute('data-v6-target'))) a.hidden = true; });
    links = links.filter(function (a) { return !a.hidden; });
    /* A126: nur noch „Overview“ und kein Datenblatt-Knopf: ganze Leiste aus (wie CSS-Regel in product-v60.css). */
    if (links.length <= 1 && !nav.querySelector('.v6-dl')) { var navSec = nav.closest('.shopify-section'); (navSec || nav).hidden = true; }
    var ticking = false;
    var update = function () {
      ticking = false;
      var off = nav.getBoundingClientRect().bottom + 40, k = -1;
      links.forEach(function (a, i) {
        var t = document.getElementById(a.getAttribute('data-v6-target'));
        if (t && t.getBoundingClientRect().top < off) k = i;
      });
      links.forEach(function (a, i) { a.classList.toggle('is-on', i === k); if (i === k) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current'); });
    };
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  }

  /* ---------- Draufsicht: Position wählen ---------- */
  document.querySelectorAll('[data-v6-topview]').forEach(function (svg) {
    var pn = document.querySelector('[data-v6-posnum]');
    var sel = function (g) {
      svg.querySelectorAll('.v6-pos').forEach(function (x) { x.classList.toggle('is-on', x === g); x.setAttribute('aria-pressed', x === g ? 'true' : 'false'); });
      if (pn) pn.textContent = String(parseInt(g.getAttribute('data-p'), 10) + 1);
      topPos = parseInt(g.getAttribute('data-p'), 10) + 1;
      auswahlUpdate();
    };
    svg.querySelectorAll('.v6-pos').forEach(function (g) {
      g.addEventListener('click', function () { sel(g); });
      g.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); sel(g); } });
    });
  });

  auswahlRestorePos();

  if (reduced) document.documentElement.style.scrollBehavior = 'auto';
})();
